'use strict';
/* COMPONENT - c.01.02 - navigation */

export default class HeaderNav {

    constructor(element) {
        this.root = element;
        this.searchBtn = this.root.querySelector('.navigation-buttons .search');
        this.searchComponent = this.root.querySelector('.navigation-search');
        this.bodyOverlay = document.querySelector('.overlay');
        this.menuBtn = this.root.querySelector('.navigation-buttons .menu');
        this.searchSubBtn = this.searchComponent.querySelector('button');
        this.navComponent = this.root.querySelector('.navigation');
        this.navMainLinks = this.navComponent.querySelectorAll('ul.main > li:not(.back) > a');
        this.mobileBackBtn = this.navComponent.querySelector('ul.main > li.back');
        this.subMenus = this.navComponent.querySelectorAll('ul.main > li:not([back]) > .sub');

        this.searchText = this.searchBtn.getAttribute('data-search-text');
        if(!this.searchText){
            this.searchText = 'Search';
        }
        this.closeText = this.searchBtn.getAttribute('data-close-text');
        if (!this.closeText){
            this.closeText = 'Close';
        }
        this.menuText = this.menuBtn.getAttribute("data-menu-text");
        if (!this.menuText){
            this.menuText = 'Menu';
        }

        this.searchOpen = false;
        this.mobileMenuOpen = false;
        this.openSub = false;
        this.resizeEvent;
        this.setSubMenu();

        this.applyListeners();
        
        let i;
      for (i = 0; i < this.navMainLinks.length; i += 1) {
            if (this.navMainLinks[i].nextElementSibling && this.navMainLinks[i].nextElementSibling.classList.value === "sub") {
              this.navMainLinks[i].setAttribute("aria-expanded", "false");
              this.navMainLinks[i].setAttribute("role", "button");
            };
        }

        if (document.body.clientWidth < 769) {
            this.mobile();
        }
    }

    applyListeners() {
        let i;
        
        for (i = 0; i < this.navMainLinks.length; i += 1) {
            let children,
                a = this.navMainLinks[i].querySelector('a'),
                ii;

            this.navMainLinks[i].addEventListener('mouseover', this.handleNavMousein.bind(this, this.navMainLinks[i]));
//            this.navMainLinks[i].addEventListener('focus', this.handleNavMousein.bind(this, this.navMainLinks[i]));
            this.navMainLinks[i].addEventListener('mouseout', this.handleNavMouseout.bind(this, this.navMainLinks[i]));
            this.navMainLinks[i].addEventListener('blur', this.removeActive.bind(this, this.navMainLinks[i]));
            this.navMainLinks[i].addEventListener('keydown', this.keyToMenu.bind(this, this.navMainLinks[i]));
            this.navMainLinks[i].addEventListener('click', this.handleNavClick.bind(this, this.navMainLinks[i]));

            if (children = this.navMainLinks[i].parentElement.querySelectorAll('.sub li a')) {
                for (ii = 0; ii < children.length; ii += 1) {
                    children[ii].addEventListener('focus', this.showSubMenu.bind(this, this.navMainLinks[i].parentElement.querySelector('.sub')));
                    children[ii].addEventListener('blur', this.subItemBlurHandler.bind(this, this.navMainLinks[i].parentElement.querySelector('.sub'), children));
                    children[ii].addEventListener('keydown', this.keyToSubMenu.bind(this, this.navMainLinks[i].parentElement.querySelector('.sub')));
                }
            }
        }

        for (i = 0; i < this.subMenus.length; i += 1) {
            this.subMenus[i].addEventListener('mouseover', this.showSubMenu.bind(this, this.subMenus[i]));
            this.subMenus[i].addEventListener('mouseout', this.hideSubMenu.bind(this, this.subMenus[i]));
        }

        this.searchBtn.addEventListener('click', this.handleSearchBtnClick.bind(this));
        this.bodyOverlay.addEventListener('click', this.closeSearch.bind(this));

        this.menuBtn.addEventListener('click', this.handleMenuBtnClick.bind(this));
        this.mobileBackBtn.addEventListener('click', this.closeSubMenu.bind(this));
        
        this.searchSubBtn.addEventListener('keydown', this.searchSubBlur.bind(this));
        this.searchBtn.addEventListener('keydown', this.searchBlur.bind(this));
        
        window.addEventListener('resize', this.resizeTimer.bind(this));
    }
    
    searchBlur(event) {
        if (event.keyCode === 9 && event.shiftKey && this.searchOpen) {
            event.preventDefault();
            event.stopPropagation();
            
            this.searchSubBtn.focus();
        }
    }
    
    searchSubBlur(event) {
        if (event.keyCode === 9 && !event.shiftKey && this.searchOpen) {
            event.preventDefault();
            event.stopPropagation();
            
            this.searchBtn.focus();
        }
    }

    removeActive(navItem) {
        let sub,
            i,
            children = navItem.parentElement.querySelectorAll('.sub li a'),
            hide = true;
        
        for (i = 0; i < children.length; i += 1) {
            if (event.relatedTarget == children[i]) {
                hide = false;
            }
        }

        navItem.parentElement.classList.remove('active');
        
        if (sub = navItem.nextElementSibling && hide) {
            this.hideSubMenu(sub);
        }
    }

    handleNavMousein(navItem) {
        let sub;
        if (sub = navItem.nextElementSibling) {
            this.showSubMenu(sub);
        }
    }

    handleNavMouseout(navItem) {
        let sub;
        if (sub = navItem.nextElementSibling) {
            this.hideSubMenu(sub);
        }
    }

    handleNavClick(navItem, e) {
        let sub,
            navItemParent = navItem.parentElement;

        if (navItemParent.querySelector('.sub') && document.body.clientWidth < 769 && !navItemParent.classList.contains('open')) {
            e.preventDefault();

            this.openSubMenu(navItemParent);
            navItem.setAttribute('tabindex', '-1');
        }
    }

    subItemBlurHandler(sub, children, event) {
        let hide = true,
            i;

        for (i = 0; i < children.length; i += 1) {
            if (event.relatedTarget == children[i]) {
                hide = false;
            }
        }

        if (hide) {
            sub.parentElement.classList.remove('active');
            this.hideSubMenu(sub);
        }
    }

    keyToSubMenu(sub, event) {
        const PARENT_NAV_ITEM = sub.parentElement,
            NEXT_NAV_ITEM = PARENT_NAV_ITEM.nextElementSibling,
            PREV_NAV_ITEM = PARENT_NAV_ITEM.previousElementSibling;

        switch (event.keyCode) {
            case 39: //right arrow
                event.preventDefault();
                event.stopPropagation();

                sub.classList.remove('active');
                PARENT_NAV_ITEM.classList.remove('active');
                NEXT_NAV_ITEM.classList.add('active');
                NEXT_NAV_ITEM.querySelector('a').focus();
                break;
            case 37: //left arrow
                event.preventDefault();
                event.stopPropagation();

                sub.classList.remove('active');
                PARENT_NAV_ITEM.classList.remove('active');
                PREV_NAV_ITEM.classList.add('active');
                PREV_NAV_ITEM.querySelector('a').focus();
                break;
        }
    }


    keyToMenu(navItem, event) {
        const NEXT_ITEM = navItem.parentElement.nextElementSibling,
            PREV_ITEM = navItem.parentElement.previousElementSibling;
        let sub = navItem.querySelector('.sub');

        switch (event.keyCode) {
            case 13: // enter
                event.preventDefault();     
                event.stopPropagation();
                this.handleNavMousein(navItem);
                break;
            case 9: // tab
                if ((NEXT_ITEM && !event.shiftKey && navItem.getAttribute('aria-expanded') == 'false') || (PREV_ITEM && event.shiftKey && !PREV_ITEM.classList.contains('back'))) {
                    event.preventDefault();
                    event.stopPropagation();

                    for (let i = 0; i < this.subMenus.length; i++) {
                        this.subMenus[i].classList.remove('active');
                    }

                    navItem.parentNode.classList.remove('active');

                    if (event.shiftKey) {
                        PREV_ITEM.classList.add('active');
                        PREV_ITEM.querySelector('a').focus();
                    } else {
                        NEXT_ITEM.classList.add('active');
                        NEXT_ITEM.querySelector('a').focus();
                    }
                }
                break;
            case 39: //right arrow
                event.preventDefault();
                event.stopPropagation();
                if (NEXT_ITEM) {
                    for (let i = 0; i < this.subMenus.length; i++) {
                        this.subMenus[i].classList.remove('active');
                        this.hideSubMenu(this.subMenus[i]);
                    }

                    navItem.parentNode.classList.remove('active');
                    NEXT_ITEM.classList.add('active');
                    NEXT_ITEM.querySelector('a').focus();
                }
                break;
            case 37: //left arrow
                event.preventDefault();
                event.stopPropagation();

                for (let i = 0; i < this.subMenus.length; i++) {
                    this.subMenus[i].classList.remove('active');
                    this.hideSubMenu(this.subMenus[i]);
                }

                navItem.parentNode.classList.remove('active');
                PREV_ITEM.classList.add('active');
                PREV_ITEM.querySelector('a').focus();
                break;
            case 27: // escape  
                event.preventDefault();
                event.stopPropagation();
                for (let i = 0; i < this.subMenus.length; i++) {
                  this.subMenus[i].classList.remove("active");
                  this.hideSubMenu(this.subMenus[i]);
                }
                break;
        }
    }

    showSubMenu(sub) {
        sub.parentElement.classList.add('active');
        sub.classList.add('active');
        if (document.body.clientWidth > 768) {
            this.bodyOverlay.classList.add('show');
            sub.parentElement.querySelector('a').setAttribute('aria-expanded', 'true');
        }
    }

    hideSubMenu(sub) {
        if (sub.parentElement) {
            sub.parentElement.classList.remove('active');
            if (document.body.clientWidth > 769) {
                sub.parentElement.querySelector('a').setAttribute('aria-expanded', 'false');
            }
            sub.classList.remove('active');
            this.bodyOverlay.classList.remove('show');
        }
    }

    openSubMenu(navItem) {
        let sub = navItem.querySelector('.sub');
        sub.parentElement.querySelector('a').setAttribute('aria-expanded', 'true');
        navItem.classList.add('open');
        navItem.parentElement.classList.add('open');
        this.openSub = navItem;
        this.searchComponent.classList.remove('active');
        sub.classList.add('open');
    }

    closeSubMenu() {
        let sub = this.openSub.querySelector('.sub');
        sub.parentElement.querySelector('a').setAttribute('aria-expanded', 'false');
        this.openSub.querySelector('a').removeAttribute('tabindex');
        this.openSub.classList.remove('open');
        this.openSub.parentElement.classList.remove('open');
        this.searchComponent.classList.add('active');
        sub.classList.remove('open');
    }

    handleSearchBtnClick() {
        if (this.searchOpen) {
            this.closeSearch();
        } else {
            this.openSearch();
        }
    }

    openSearch() {
		this.searchOpen = true;
        this.searchBtn.classList.add('active');
        this.searchBtn.querySelector('.navigation-buttons-text').innerHTML = this.closeText;
        this.searchBtn.setAttribute('aria-expanded', true);
        this.searchComponent.classList.add('active');
        this.bodyOverlay.classList.add('show');
        this.navComponent.classList.add('hide');
        document.body.style.position = 'fixed';
        this.searchComponent.querySelector('input[type="text"]').focus();
        document.querySelector('main').setAttribute('aria-hidden', 'true');
    }

    closeSearch() {
        this.searchOpen = false;
        this.searchBtn.classList.remove('active');
        this.searchBtn.querySelector('.navigation-buttons-text').innerHTML = this.searchText;
        this.searchBtn.setAttribute('aria-expanded', false);
        this.searchComponent.classList.remove('active');
        this.bodyOverlay.classList.remove('show');
        this.navComponent.classList.remove('hide');
        // I removed the static position here to stop the footer jumping up the screen, the empty position will remove the added one for when the search is opened.
        document.body.style.position = '';
        document.querySelector('main').setAttribute('aria-hidden', 'false');
    }

    handleMenuBtnClick() {
        if (this.mobileMenuOpen) {
            this.closeMobileMenu();
        } else {
            this.openMobileMenu();
        }
    }

    openMobileMenu() {
        this.mobileMenuOpen = true;
        this.menuBtn.classList.add('active');
        this.menuBtn.setAttribute('aria-expanded', true);
        this.menuBtn.querySelector('.navigation-buttons-text').innerHTML = this.closeText;
        this.searchComponent.classList.add('active');
        this.navComponent.classList.add('active');
        this.navComponent.querySelector('a').focus();
        document.documentElement.classList.add('menu-open');
    }

    closeMobileMenu() {
        if (this.openSub) {
            this.closeSubMenu();
        }
        this.mobileMenuOpen = false;
        this.menuBtn.classList.remove('active');
        this.menuBtn.setAttribute('aria-expanded', false);
        this.menuBtn.querySelector('.navigation-buttons-text').innerHTML = this.menuText;
        this.searchComponent.classList.remove('active');
        this.navComponent.classList.remove('active');
        document.documentElement.classList.remove('menu-open');
    }
    
    setSubMenu() {
        let clientWidth = window.innerWidth,
            i;
        
        if (clientWidth => 768) {
            for (i = 0; i < this.subMenus.length; i += 1) {
                let links = this.subMenus[i].querySelectorAll('.children li'),
                    pop = this.subMenus[i].querySelector('.popular'),
                    split = Math.ceil(links.length / ((pop ? 2 : 3) - (clientWidth < 1025 ? 1 : 0))),
                    ii;

                if (links.length && (clientWidth > 1024) || !pop) {
                    this.subMenus[i].querySelector('.children ul').style.height = split * 41 + 66 + 'px';
                    for (ii = 0;  ii < links.length; ii += 1) {
                        if (ii > split * (pop || clientWidth < 1024 ? 1 : 2) - 1) {
                            links[ii].classList.add('no-border');
                        }
                    }
                } else {
                    this.subMenus[i].querySelector('.children ul').style.height = 'auto';
                }
            }
        } else {
            for (i = 0; i < this.subMenus.length; i += 1) {
                this.subMenus[i].querySelector('.children ul').style.height = 'auto';
            }
        }
    }
    
    resizeTimer() {
        clearTimeout(this.resizeEvent);
        this.resizeEvent = setTimeout(this.setSubMenu.bind(this), 100);
    }

    mobile() {
        this.searchComponent.querySelector('input[type="text"]').setAttribute('placeholder', this.searchText);
    }
}
